import RcPagination from 'rc-pagination';
import classNames from 'classnames';
import './styles.css';
import Icon from '../../Atoms/Icon';

interface Props {
  defaultCurrent?: number;
  total?: number;
  pageSize?: number;
  className?: string;
  simple?: boolean;
  prevButtonText?: string;
  nextButtonText?: string;
}

interface ButtonProps {
  className?: string;
  simple?: boolean;
  children: string | number | JSX.Element;
}

function Button({
  children,
  simple = false,
  className
}: ButtonProps) {
  return !simple ? (
    <div
      className={classNames(
        className,
        'button inline-flex w-9 cursor-pointer select-none items-center justify-center border-r border-[rgba(35,39,91,.1)] p-1 text-center text-sm font-thin text-sl-gray duration-300 hover:text-sl-blue-dark'
      )}
    >
      {children}
    </div>
  ) : (
    <div
      className={classNames(
        className,
        'button w-9 cursor-pointer select-none p-2 text-center text-sm font-thin text-sl-gray duration-300 hover:text-sl-yellow'
      )}
    >
      {children}
    </div>
  );
}

function Pagination({
  defaultCurrent,
  total,
  pageSize,
  className,
  simple = false,
  prevButtonText = 'Prev',
  nextButtonText = 'Next'
}: Props) {
  const render = (
    current: number,
    type:
      | 'page'
      | 'prev'
      | 'next'
      | 'jump-prev'
      | 'jump-next',

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    element: any
  ) => {
    if (type === 'page') {
      return <Button simple={simple}>{current}</Button>;
    }
    if (type === 'jump-prev' || type === 'jump-next') {
      return !simple ? <Button>...</Button> : null;
    }
    if (type === 'prev') {
      return (
        <Button
          className="min-h-[36px] w-auto min-w-[36px] border-l-transparent py-2 px-2 xsm:px-4"
          simple={simple}
        >
          <span>
            <span className="hidden xsm:inline">
              {prevButtonText}
            </span>
            <span className="flex items-center xsm:hidden">
              <Icon icon="chevron-left" />
            </span>
          </span>
        </Button>
      );
    }
    if (type === 'next') {
      return (
        <Button
          className="min-h-[36px] w-auto min-w-[36px] border-r-transparent py-2 px-2 xsm:px-4"
          simple={simple}
        >
          <span>
            <span className="hidden xsm:inline">
              {nextButtonText}
            </span>
            <span className="flex items-center xsm:hidden">
              <Icon icon="chevron-right" />
            </span>
          </span>
        </Button>
      );
    }
    return element;
  };
  return (
    <div className="mx-auto flex w-full max-w-7xl flex-col items-center justify-center py-7 md:px-5">
      <RcPagination
        defaultCurrent={defaultCurrent || 1}
        showTitle={false}
        showLessItems
        className={classNames([
          simple && 'simple',
          !simple &&
            'rounded-l-md rounded-r-md border border-[rgba(35,39,91,.1)]',
          'flex',
          className
        ])}
        pageSize={pageSize || 10}
        total={total || 100}
        itemRender={render}
      />
    </div>
  );
}

export default Pagination;
